/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown> }} Chat_Browser_Frame_CounterInputs */



/**
* | output |
* | --- |
* | "Frame {current}" |
*
* @param {Chat_Browser_Frame_CounterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_browser_frame_counter = /** @type {((inputs: Chat_Browser_Frame_CounterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Browser_Frame_CounterInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Bild ${i?.current}`)
	return /** @type {LocalizedString} */ (`Frame ${i?.current}`)
});